// IMPORTANT
// This is an indicator that user has to go though tax withholdings setup flow
// It's not an indicator whether tax withholdings activated or not

import { InternalAccount } from "@wingspanhq/wingspan-api-sdk";

export const selectorIsTaxWithholdingsSetupComplete = (params: {
  withholdingRate?: number;
  internalAccounts?: InternalAccount[];
}) => {
  // User has to have tax rate set
  if (!params.withholdingRate) {
    return false;
  }

  // User has to have tax withholding account
  // It's doesn't have to be active in terms of setup completion, but it has to exist
  const hasTaxWithholdingAccount = params.internalAccounts?.some(
    internalAccount => internalAccount.type === "TaxWithholding"
  );

  if (!hasTaxWithholdingAccount) {
    return false;
  }

  return true;
};
